import api from './api';

export async function getRestaurantOffers(
  restaurantId,
  { page = 1, limit = 20, isActive, sort = 'newest' } = {}
) {
  const params = { page, limit, sort };
  if (typeof isActive === 'boolean') params.isActive = isActive;
  const response = await api.get(`/admin/restaurants/${restaurantId}/offers`, { params });
  return response.data;
}

export async function createRestaurantOffer(restaurantId, payload) {
  const response = await api.post(`/admin/restaurants/${restaurantId}/offers`, payload);
  return response.data;
}

export async function updateRestaurantOffer(restaurantId, offerId, payload) {
  const response = await api.patch(`/admin/restaurants/${restaurantId}/offers/${offerId}`, payload);
  return response.data;
}

export async function deleteRestaurantOffer(restaurantId, offerId) {
  const response = await api.delete(`/admin/restaurants/${restaurantId}/offers/${offerId}`);
  return response.data;
}
